import React from 'react';

import { CoreLink as RDCCoreLink } from '@uncinc/react-drupal-core';
import type { CoreLinkProps } from '@uncinc/react-drupal-core/dist/Components/CoreLink';

import { IS_REACT_NATIVE } from '../../config/constants';

const CoreLink: React.FC<CoreLinkProps> = (props) => (
  <RDCCoreLink {...props} draggable={!IS_REACT_NATIVE} />
);

export default CoreLink;
